export const isCompact = density => density === 'compact';
export const isModernized = variant => variant === 'modernized';